import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconOrderedList from '@src/assets/images/common/icon/editor/SvgIconOrderedList';
import type { Editor } from '@tiptap/react';
import React from 'react';

import { handleOrderedListToggle } from '../../../handlers/listHandlers';

interface OrderedListButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const OrderedListButton: React.FC<OrderedListButtonProps> = ({
  editor,
  isActive,
  refreshActiveState,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => handleOrderedListToggle(editor, refreshActiveState)}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='箇条書き（数字）'
      type='button'
    >
      <SvgIconOrderedList color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
